import moment from 'moment';
import * as React from 'react';

export interface IDateTimeProps {
  initialVal?: string;
  isLive: boolean;
  updateInterval?: number;
  onFormat: any;
}

export default function DateTime(props: IDateTimeProps) {
  const {
    initialVal,
    isLive = false,
    updateInterval = 1000,
    onFormat = (dateVal: any) => dateVal.format(),
  } = props;
  const [dateVal, setDateVal] = React.useState<any>();
  const [intervalRef, setIntervalRef] = React.useState<any>();
  React.useEffect(() => {
    setDateVal(initialVal);
  }, [initialVal]);
  React.useEffect(() => {
    if (isLive) {
      const iRef = setInterval(() => {
        setDateVal(moment());
      }, updateInterval);
      setIntervalRef(iRef);
    }
    return () => {
      clearInterval(intervalRef);
    };
  }, []);
  return <span>{dateVal ? onFormat(dateVal) : ''}</span>;
}
